import { useCompany, useCompanyCanonicalUrl } from '@/hooks/useCompany';
import type Company from '@simplywallst/services/lib/endpoints/types/company/Company';
import { useSection } from '../useSection';
import routesGenerator from '@/router/routesGenerator';
import { useLocation } from '@/hooks/useLocation';
import queryString from 'query-string';
import { pathToAction } from 'redux-first-router';
import { isLocaleRouteType } from '@/utils/locale';

function getDividendYield(company?: Company) {
  return company?.analysis?.data.extended.data.analysis.dividend.dividend_yield;
}

function useShouldNoIndexFollow() {
  const { currentSection } = useSection();
  const canonicalUrl = useCompanyCanonicalUrl();
  const company = useCompany(canonicalUrl);
  const dividendYield = getDividendYield(company.data?.data);

  const isBlockedAsInsufficientDividend =
    (dividendYield === 0 || dividendYield === null) &&
    currentSection === 'dividend';

  const location = useLocation();
  const action = pathToAction(
    location.pathname,
    routesGenerator(),
    queryString
  );

  // Locale routes should not be indexed until fully released.
  const isLocaleRoute = isLocaleRouteType(action.type);

  return isBlockedAsInsufficientDividend || isLocaleRoute;
}
export default useShouldNoIndexFollow;
